import { ref } from 'vue';
import EinvoicingReceiver from '~/app/einvoicing/models/EinvoicingReceiver';
import EinvoicingReceiverNetwork from '~/app/einvoicing/models/EinvoicingReceiverNetwork';
import EinvoicingReceiverCollection from '~/app/einvoicing/collections/EinvoicingReceiverCollection';
import { ModelType } from '~/app/base/schemas/BaseSchema';
import { EINVOICING_PROVIDER_TYPE, EinvoicingProviderType } from '~/app/einvoicing/enums/EinvoicingProviderType';
import { EINVOICING_NETWORK_TYPE, EinvoicingNetworkType } from '~/app/einvoicing/enums/EinvoicingNetworkType';

export function useGetEinvoicingReceiver(providerType: EinvoicingProviderType = EINVOICING_PROVIDER_TYPE.STORECOVE, networkType: EinvoicingNetworkType = EINVOICING_NETWORK_TYPE.PEPPOL) {
    const receiver = ref<EinvoicingReceiver | null>(null);
    const receiverNetwork = ref<EinvoicingReceiverNetwork | null | undefined>(null);

    const { load, loading, collection } = useCollectionLoader<EinvoicingReceiver, EinvoicingReceiverCollection>(ModelType.EINVOICING_RECEIVERS, [], () => ({
        include: 'einvoicingReceiverNetworks',
        filter: {
            providerType,
            einvoicingReceiverNetworks: {
                networkType,
            },
        },
    }));

    const loadReceiver = async () => {
        await load();
        receiver.value = collection.value?.getAt(0) ?? null;
        receiverNetwork.value = receiver.value?.einvoicingReceiverNetworks?.last() ?? null;
    };

    const isEinvoicingReceiverNetworkActivated = computed(() => {
        return Boolean(receiverNetwork.value);
    });

    return { load: loadReceiver, loading, collection, receiver, receiverNetwork, isEinvoicingReceiverNetworkActivated };
}
